export default __webpack_public_path__ + "static/media/gallery3.062e3d3d.jpg";